export default __webpack_public_path__ + "static/media/ibobby_RIP_small.6e3e7f99.png";